import React, { useState } from 'react';
import useGetBrowseFrame from "../../../hooks/useGetBrowseFrame";
import SpinnerComponent from "../../reusable/SpinnerComponent";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { TimelineState } from "../../../store/timeline/types";
import ThumbnailPaneComponent from "../../reusable/ThumbnailPaneComponent";
import { LayoutState } from '../../../store/layouts/types';
import MapComponent from '../../reusable/MapComponent';
import WebPageComponent from '../../reusable/WebPageComponent';

// import {SettingsState} from "../../../store/settings/types";

interface Props {
  pane: number
}

// TODO
// Create wrapper to detect Component type

const ThumbnailComponent: React.FC<Props> = ({pane}) => {
  const {initialCameras} = useSelector<ApplicationState, LayoutState>(state => state.layouts);
  const {time} = useSelector<ApplicationState, TimelineState>(state => state.timeline);
  const src = useGetBrowseFrame(pane, time, true);
  const [imgState, setImageState] = useState<'fetch' | 'error' | 'success'>('fetch');

  const imgOnSuccess = () => setImageState('success');
  const imgOnError = () => setImageState('error');

  return (
    <div className='w-100 h-100 flex al-it-c js-c' id={`pane-${pane}`}>
      {
        initialCameras[pane - 2] && (initialCameras[pane - 2].type === 'Map')
          ? <MapComponent pane={pane - 2} mapId={initialCameras?.[pane - 2]?.id}/>
          : initialCameras[pane - 2] && (initialCameras[pane - 2].type === 'WebPage')
            ? <WebPageComponent webPageId={initialCameras?.[pane - 2]?.id}/>
            : src && <>
              <ThumbnailPaneComponent
                src={src}
                pane={pane}
                camID={initialCameras?.[pane - 2]?.id}
                onLoad={imgOnSuccess}
                onError={imgOnError}
                visible={imgState === 'success'}
              />
              <div className='flex js-c al-it-c o-hidden pos-abs'>
                {imgState === 'fetch' && <SpinnerComponent/>}
              </div>
            </>
      }
    </div>
  )
};

export default ThumbnailComponent